import React, { useMemo } from "react";
import { useNavToggle } from "../../shared/nav-toggler/useNavToggle";
import LeftNavigation from "../../widgets/supervisor/nav-section/LeftNavigation";
import TopNavigation from "../../widgets/supervisor/nav-section/TopNavigation";
import useFetchWithAuth from "../../features/hooks/useFetchWithAuth";

function Layout({ children }) {
  const { active, toggleActive } = useNavToggle();

  // Загружаем CRM-ы как у клиента
  const { data: crms, loading, error } = useFetchWithAuth("/user/me/crms");

  // Подменю дашборда
  const dashboardSubMenu = useMemo(() => {
    if (!Array.isArray(crms)) return [];
    return crms.map((crm) => ({
      label: crm.name,
      path: `/supervisor/dashboard/${crm.id}`, // отличие: путь для супервизора
    }));
  }, [crms]);

  // Секции меню
  const menuSections = useMemo(
    () => [
      {
        title: "Сторінки",
        items: [
          {
            label: "Дашборд",
            icon: "dashboard",
            panelId: "dashboard-panel",
            subMenu: dashboardSubMenu,
          },
          {
            label: "Скрипти",
            path: "/supervisor/scripts/",
            icon: "contact_page",
          },
          {
            label: "FAQ",
            path: "/supervisor/faq/",
            icon: "auto_stories",
          },
        ],
      },
    ],
    [dashboardSubMenu]
  );

  return (
    <div className={`${active ? "active" : ""}`}>
      {loading && <p>Loading...</p>}
      {error && <p>Error: {error.message}</p>}

      {!loading && !error && (
        <>
          <LeftNavigation
            toggleActive={toggleActive}
            menuSections={menuSections}
          />
          <TopNavigation toggleSidebar={toggleActive} />
          <div className="main-content">{children}</div>
        </>
      )}
    </div>
  );
}

export default Layout;
